export enum actionTypes {
    BANNER_FEED_DATA_UPDATE = 'BANNER_FEED_DATA_UPDATE'
}
